export type NavLink = {
    label: string
    href: string
}

export const MAIN_NAV: Array<NavLink> = [
    { label: "Services", href: '/services' },
    { label: "Real weddings", href: '/weddings' },
    { label: "Ceremonies", href: '/#ceremonies' },
    { label: "Destinations", href: '/#destinations' },
    { label: "Contact", href: '/contact' }
]

export const FOOTER_NAV: Array<{ title: string, links: Array<NavLink> }> = [
    {
        title: "Explore",
        links: [
            { label: "Home", href: '/' },
            { label: "Services", href: '/services' },
            { label: "Real weddings", href: '/weddings' },
            { label: "Contact", href: '/contact' }
        ]
    },
    {
        title: "Planning",
        links: [
            { label: "Ceremonies we plan", href: '/#ceremonies' },
            { label: "Destinations", href: '/#destinations' },
            { label: "How it works", href: '/services#process' },
            { label: "Questions couples ask", href: '/services#faq' }
        ]
    }
]
